<script>
    import {Facebook, LinkedIn, Twitter, WhatsApp} from "svelte-share-buttons-component";
    import {onMount} from "svelte";

    let currentUrl = window.location.href;
    let currentTitle;

    setTimeout(() => {
        currentTitle = document.title;
    }, 200);

    function updateLocation() {
        currentUrl = window.location.href;
        setTimeout(() => {
            currentTitle = document.title;
        }, 100);
    }

    onMount(() => {
        setTimeout(() => {
            document.querySelector('.share').style.display = 'flex';
        }, 500);
    });
</script>

<svelte:window on:popstate={updateLocation} on:pushstate={updateLocation} />

<div class="share colligo-share" style="display: none;">
    <div class="colligo-share-title">Udostępnij przez:</div>
    <div>
        <LinkedIn class="share-button colligo-share-button" url={currentUrl} />
        <WhatsApp class="share-button colligo-share-button" text="{currentTitle} url={currentUrl}" />
        <Facebook class="share-button colligo-share-button" quote="{currentTitle}" url={currentUrl} />
        <Twitter class="share-button colligo-share-button" text="{currentTitle}" url={currentUrl} hashtags="colligo,torun,bydgoszcz" related="other,users" />
    </div>
</div>

<style lang="scss">
  @import "../styles/share-buttons";
</style>